export const breakpoints = {
  mobile: 320,
  tablet: 768,
  computer: 992,
  largeTablet: 1024,
  largeMonitor: 1200,
  widescreen: 1920,
  largestMobile: 767,
  largestTablet: 991,
  largestComputer: 1199,
  largestLargeMonitor: 1919,
};
